<div class="terms-container ">
    <div class="logo">
        <img src="/assets/img/phoenix-logo.png" alt="phoenix" class="logo-phoenix">
    </div>
    <h1 class="terms-title">TÉRMINOS Y CONDICIONES DE USO DEL SITIO WEB Y APPWEB</h1>

    <h2 class="terms-section-title">Identificación del titular y aceptación</h2>
    <p class="terms-paragraph">
        El presente documento regula el acceso y uso del sitio web https://www.phoenix.com.pe y de la AppWeb Phoenix (en conjunto, la "Web y AppWeb" o la "Plataforma"), de titularidad de Phoenix Group S.A.C., RUC 20609872463, con nombre comercial "Phoenix | Enhancing Silver Value", con domicilio en Calle 2 de Mayo N.º 516, oficina 201, Miraflores, Lima, Perú, y correo de contacto informes&#64;phoenix.com.pe.
    </p>
    <p class="terms-paragraph">
        Al acceder, navegar o utilizar la Web y AppWeb, el usuario (el "Usuario") declara haber leído, comprendido y aceptado íntegramente estos Términos y Condiciones y las políticas complementarias (incluida la Política de Privacidad y Protección de Datos Personales). Si no está de acuerdo, debe abstenerse de usar la Web y AppWeb.
    </p>
    <p class="terms-paragraph">
        Phoenix podrá modificar estos Términos en cualquier momento, publicando la versión vigente en la Web y AppWeb. El uso posterior implica aceptación de las modificaciones.
    </p>
    <p class="terms-paragraph">
        La Web y AppWeb están dirigidas principalmente a personas mayores de cincuenta (50) años; sin perjuicio de ello, solo pueden contratar mayores de edad con capacidad legal.
    </p>

    <h2 class="terms-section-title">1. Descripción del Servicio</h2>
    
    <h3 class="terms-subsection-title">Alcance del servicio</h3>
    <p class="terms-paragraph">
        Phoenix es una Plataforma Web y AppWeb que facilita el acceso a programas formativos, experiencias, mentorías, talleres, sesiones grupales, asesorías y contenidos digitales orientados a la reinvención, longevidad activa y bienestar integral de personas 50+. Los Usuarios podrán registrarse, suscribirse y acceder a productos como Executive Program, Professional, Founder B2B, Phoenix Sessions, y otros que Phoenix incorpore.
    </p>

    <h3 class="terms-subsection-title">Relación con terceros expertos</h3>
    <p class="terms-paragraph">
        Phoenix actúa como facilitador y administrador tecnológico del entorno digital y de la conexión entre Usuarios, mentores, expertos o aliados autorizados. La participación de terceros no genera relación laboral, societaria ni de representación con Phoenix, salvo acuerdo expreso.
    </p>
    <p class="terms-paragraph">
        Los mentores, expertos o aliados actúan de manera independiente y en virtud de contratos civiles o comerciales. El Usuario reconoce que sus intervenciones no sustituyen asesoramiento profesional especializado en salud, finanzas, psicología, derecho o disciplinas equivalentes, y que los contenidos tienen naturaleza formativa y orientativa.
    </p>
    <p class="terms-paragraph">
        El acceso a ciertos servicios puede requerir registro previo, aceptación de políticas específicas, validación de identidad y/o pago según la modalidad contratada, tanto en la Web como en la AppWeb.
    </p>
    <p class="terms-paragraph">
        Phoenix podrá actualizar, mejorar o modificar los programas o contenidos disponibles, garantizando siempre que las variaciones no afectarán los derechos adquiridos por los Usuarios que hayan contratado un servicio específico.
    </p>

    <h2 class="terms-section-title">2. Condiciones de Uso y Responsabilidad del Usuario</h2>
    <p class="terms-paragraph">
        El Usuario se compromete a utilizar la Web y AppWeb de forma lícita, ética y de buena fe, respetando la normativa vigente y derechos de terceros. Se prohíbe el uso de la Web y AppWeb para fines ilícitos o contrarios a la moral; vulnerar derechos de autor o marcas; introducir malware o ingeniería inversa; o suplantar identidad.
    </p>
    <p class="terms-paragraph">
        El Usuario es responsable de la confidencialidad de sus credenciales y de toda actividad desde su cuenta. Debe notificar de inmediato a informes&#64;phoenix.com.pe ante usos no autorizados.
    </p>
    <p class="terms-paragraph">
        El contenido y recomendaciones de la Web y AppWeb tienen carácter formativo e informativo y no sustituyen asesoramiento profesional personalizado.
    </p>
    <p class="terms-paragraph">
        El Usuario declara comprender que el aprovechamiento de los contenidos depende de su participación activa, compromiso personal y cumplimiento de las instrucciones generales de uso de la Plataforma.
    </p>

    <h2 class="terms-section-title">3. Precios y Condiciones de Pago</h2>
    
    <h3 class="terms-subsection-title">Información sobre precios</h3>
    <p class="terms-paragraph">
        Los precios se expresan en USD o PEN, según se indique en la Web o AppWeb o en comunicaciones comerciales. Phoenix podrá modificar precios; rigen los vigentes al momento de la contratación.
    </p>
    <p class="terms-paragraph">
        Phoenix informará claramente el precio total antes de la confirmación final de compra, incluyendo comisiones o cargos aplicables, en cumplimiento de las normas de comercio electrónico.
    </p>

    <h3 class="terms-subsection-title">Medios de pago</h3>
    <p class="terms-paragraph">
        Los pagos se realizan mediante pasarelas de pago en línea, transferencias bancarias u otros mecanismos electrónicos autorizados. El Usuario declara que los datos de pago son veraces y actuales.
    </p>
    <p class="terms-paragraph">
        El procesamiento por terceros (bancos o pasarelas) se rige por sus términos y políticas. Phoenix no responde por fallas o rechazos imputables a dichos sistemas.
    </p>

    <h3 class="terms-subsection-title">Suscripciones y cargos recurrentes</h3>
    <p class="terms-paragraph">
        En suscripciones recurrentes, el Usuario autoriza el cargo automático periódico hasta su cancelación conforme al procedimiento establecido.
    </p>
    <p class="terms-paragraph">
        Phoenix informará con claridad, antes del pago, cuando un servicio implique renovación automática, y pondrá a disposición del Usuario un mecanismo sencillo para cancelarla. Asimismo, el Usuario recibirá un aviso previo razonable antes de cada renovación, pudiendo optar por no continuar.
    </p>
    <p class="terms-paragraph">
        Phoenix emitirá comprobante de pago (boleta o factura) conforme a ley.
    </p>
    <p class="terms-paragraph">
        Incumplimiento, fraude o reversión no justificada faculta a Phoenix a suspender o cancelar el acceso, sin perjuicio de acciones legales de cobro.
    </p>

    <h2 class="terms-section-title">4. Cambios, Devoluciones y Reembolsos</h2>
    <p class="terms-paragraph">
        Dado el carácter digital e intangible de los servicios, no hay cambios o devoluciones una vez iniciado el acceso o prestación, salvo los supuestos establecidos o los exigidos por ley.
    </p>
    <p class="terms-paragraph">
        Se considera iniciada la prestación cuando Phoenix habilita el acceso a los contenidos o sesiones adquiridas, dependiendo de la naturaleza del servicio. Esta precisión responde al deber de información del proveedor y evita confusiones sobre el uso efectivo del servicio digital.
    </p>
    <p class="terms-paragraph">
        Phoenix podrá evaluar reembolsos por error o duplicidad de cobro, cancelación del servicio antes de su inicio o falla técnica comprobada.
    </p>
    <p class="terms-paragraph">
        Las solicitudes deberán enviarse a informes&#64;phoenix.com.pe dentro de 7 días calendario. Phoenix responderá en 15 días hábiles.
    </p>
    <p class="terms-paragraph">
        Phoenix procurará brindar soluciones alternativas cuando sea posible, tales como reprogramaciones, créditos a favor del Usuario o acceso extendido, manteniendo siempre un estándar razonable conforme al Código del Consumidor.
    </p>
    <p class="terms-paragraph">
        Los reembolsos aprobados se efectúan por el mismo medio de pago, excluyendo comisiones o costos financieros y sin reconocer diferencias de tipo de cambio.
    </p>

    <h2 class="terms-section-title">5. Tratamiento de Datos Personales</h2>
    <p class="terms-paragraph">
        Phoenix Group S.A.C., RUC 20609872463, con nombre comercial "Phoenix | Enhancing Silver Value", cumple la Ley N.º 29733 y su Reglamento (D.S. N.º 003-2013-JUS). Los datos del Usuario se incorporan a un banco de datos de titularidad de Phoenix, inscrito ante la ANPDP. Finalidades: registro y autenticación, gestión contractual y de servicios, procesamiento de pagos, comunicaciones operativas, marketing (con consentimiento expreso), métricas y mejora continua (anonimización cuando corresponda).
    </p>
    <p class="terms-paragraph">
        El Usuario otorga consentimiento libre, previo, expreso e informado. Transferencias o encargos solo cuando sea necesario, obligación legal o con consentimiento. Phoenix adopta medidas de seguridad razonables, aunque reconoce que ningún sistema es infalible. Los derechos ARCO pueden ejercerse escribiendo a informes&#64;phoenix.com.pe. Los datos se conservan por el tiempo necesario y luego se eliminan o anonimizan. El Usuario declara conocer y aceptar la Política de Privacidad publicada en la Web y AppWeb.
    </p>
    <p class="terms-paragraph">
        La aceptación de estos Términos no sustituye el consentimiento expreso que debe otorgarse de manera diferenciada para las finalidades descritas en la Política de Privacidad.
    </p>

    <h2 class="terms-section-title">6. Cookies y Tecnologías de Seguimiento</h2>
    <p class="terms-paragraph">
        La Web y AppWeb utilizan cookies y tecnologías similares para optimizar la experiencia, analizar el uso y personalizar contenidos. Al usar la Web y AppWeb, el Usuario acepta su uso conforme a esta política. Puede configurarlas o eliminarlas desde su navegador. Tipos: necesarias, funcionalidad, analíticas y publicitarias (incluidos terceros). Los datos se conservan por el tiempo estrictamente necesario y luego se eliminan o anonimizan.
    </p>
    <p class="terms-paragraph">
        El uso de cookies se rige por la Política de Cookies independiente, donde se detallan categorías, finalidades y mecanismos de consentimiento granular.
    </p>

    <h2 class="terms-section-title">7. Propiedad Intelectual</h2>
    <p class="terms-paragraph">
        Todo contenido, metodologías, marcas, logotipos, textos, gráficos, videos, audios y materiales de la Web y AppWeb son propiedad de Phoenix Group S.A.C. o de sus licenciantes. Su reproducción o uso sin autorización está prohibido bajo el D. Leg. 822 – Ley sobre el Derecho de Autor.
    </p>

    <h2 class="terms-section-title">8. Modificaciones del Servicio y Disponibilidad</h2>
    <p class="terms-paragraph">
        Phoenix podrá mejorar, actualizar, modificar, suspender o descontinuar funcionalidades o servicios de la Web y AppWeb, preservando derechos adquiridos.
    </p>
    <p class="terms-paragraph">
        Phoenix garantiza que las modificaciones no afectarán negativamente servicios ya contratados y que informará previamente cualquier cambio sustancial que pueda impactar al Usuario.
    </p>
    <p class="terms-paragraph">
        La disponibilidad puede verse afectada por mantenimiento, fuerza mayor o fallas ajenas a Phoenix.
    </p>

    <h2 class="terms-section-title">9. Limitación de Responsabilidad</h2>
    <p class="terms-paragraph">
        Phoenix no garantiza operación ininterrumpida ni libre de errores en la Web y AppWeb. No será responsable por daños indirectos, lucro cesante o pérdida de datos ocasionados por fallos técnicos, fuerza mayor o decisiones del Usuario basadas en la información de la Web y AppWeb.
    </p>
    <p class="terms-paragraph">
        No obstante, Phoenix asumirá responsabilidad cuando corresponda por infracciones a los deberes de idoneidad establecidos por el Código de Protección y Defensa del Consumidor, siempre dentro de lo permitido por la ley y según la naturaleza del servicio contratado.
    </p>

    <h2 class="terms-section-title">10. Atención al Usuario y Notificaciones</h2>
    <p class="terms-paragraph">
        Consultas o solicitudes deben dirigirse a informes&#64;phoenix.com.pe. Phoenix podrá enviar notificaciones al correo registrado por el Usuario.
    </p>
    <p class="terms-paragraph">
        El Usuario podrá también acudir ante el Indecopi para la resolución de controversias en materia de consumo, sin perjuicio de los mecanismos internos de solución ofrecidos por Phoenix.
    </p>

    <h2 class="terms-section-title">11. Ley Aplicable y Jurisdicción</h2>
    <p class="terms-paragraph">
        Estos Términos se rigen por las leyes de la República del Perú. Cualquier controversia se resolverá ante los jueces del Distrito Judicial de Lima.
    </p>
    <p class="terms-paragraph">
        Esta disposición no limita la competencia administrativa del Indecopi en materias de protección al consumidor.
    </p>

    <h2 class="terms-section-title">12. Disposiciones Finales</h2>
    <p class="terms-paragraph">
        Si alguna cláusula se declara nula, las restantes conservarán su validez. La falta de ejercicio de derechos por Phoenix no implica renuncia. Esta versión rige para el uso de la Web y AppWeb de Phoenix desde su publicación en la Plataforma.
    </p>
    <p class="terms-paragraph">
        La falta de ejercicio de un derecho por parte de Phoenix se interpretará como tolerancia y no como renuncia.
    </p>

    <div class="container-button">
        <button class="boton-principal" (click)="return()">Regresar</button>
    </div>
</div>